import {
  Box,
  Button,
  Container,
  CssBaseline,
  IconButton,
  InputAdornment,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { LoginContext } from "../../../context/users/LoginContextCopy";
import axios from "axios";
import { icURL } from "../../../context/users/DataContextCopy";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="#">
        인천광역시
      </Link>
      {new Date().getFullYear()}
    </Typography>
  );
}

function AdminLogin() {
  const { LoginSubmit, loginValue, setLoginValue, isLoginState } =
    useContext(LoginContext);

  const navigate = useNavigate();

  const [values, setValues] = useState({
    showPass: false,
  });

  const togglePasswordHide = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };

  // 등록된 ip인지 확인
  const [accessGranted, setAccessGranted] = useState(false);

  useEffect(() => {
    const checkIP = async () => {
      try {
        const response = await axios.get(`${icURL}/api/ascon/validIp`);

        if (response.data) {
          console.log(accessGranted);
          setAccessGranted(true);
        } else {
          alert("접근 권한이 없습니다.");
          navigate("//");
        }
      } catch (err) {
        console.error("Error:", err);
        alert("서버 오류");
        navigate("//");
      }
    };

    checkIP();
  }, [navigate, setAccessGranted]);

  useEffect(() => {
    if (isLoginState) {
      console.log(isLoginState);
      navigate("/ascon");
    }
  }, [isLoginState, navigate]);

  if (!accessGranted) {
    return (
      <div style={{ height: "80vh", textAlign: "center", lineHeight: "80vh" }}>
        <h1>접근불가</h1>
      </div>
    ); // 접근 권한이 없으면 아무 것도 렌더링하지 않음
  }

  return (
    <main>
      <div className='declarelist-container'>
        <div className='declarelist-box'>
          <div className='declarelist-contents'>
            <div className='declare-title'>
              <div className='title'>
                <h1>아스콘 관리자 로그인</h1>
              </div>
            </div>

            <Container
              maxWidth='xs'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid white',
                margin: '2vh auto',
              }}
            >
              <CssBaseline />
              <Box
                sx={{
                  height: '40vh',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
                className='login-form'
              >
                <Box component='form' sx={{ marginTop: 10 }} onSubmit={LoginSubmit}>
                  <TextField
                    id='outlined-basic'
                    label='ID'
                    variant='outlined'
                    name='user_id'
                    autoComplete='off'
                    autoFocus
                    onChange={e =>
                      setLoginValue({
                        ...loginValue,
                        user_id: e.target.value,
                      })
                    }
                    fullWidth
                  />
                  <TextField
                    margin='normal'
                    id='outlined-basic'
                    type={values.showPass ? 'text' : 'password'}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton aria-label='toggle password' edge='end' onClick={togglePasswordHide}>
                            {values.showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    label='password'
                    variant='outlined'
                    name='user_pwd'
                    onChange={e =>
                      setLoginValue({
                        ...loginValue,
                        user_pwd: e.target.value,
                      })
                    }
                    fullWidth
                  />

                  <Button type='submit' fullWidth variant='outlined' sx={{ mt: 3, mb: 2 }}>
                    LOGIN
                  </Button>

                  <Button
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{ marginTop: '2vh' }}
                  >
                    관리자가 아닐 경우 이용 불가합니다.
                  </Button>
                </Box>
              </Box>
              <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AdminLogin;
